import { civilities } from "../../static/types/commonTypes/individualType"
import PostalCodeField from "./PostalCodeField"
import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import { HeadOfficeAddressType } from "../../static/types/commonTypes/headOfficeAddressType"
import headOfficeAddressValidationSchema from "../../utils/validation/headOfficeValidationSchema"
import { getCityWithPreposition } from "../../utils/functions/getCityWithPreposition"
import useAppContext from "../../hooks/useAppContext"
import { AppContextType } from "../../context/AppContext"

type headOfficeAddressProps = {
    checked: boolean,
    headOfficeAddress: HeadOfficeAddressType,
    changeHeadOfficeAddress: ( headOfficeAddress: Partial<HeadOfficeAddressType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function HeadOfficeAddress ({
    checked,
    headOfficeAddress,
    changeHeadOfficeAddress,
    onValidationChange
}: headOfficeAddressProps ) {
    
    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    const { errors, isValid } = useValidation( headOfficeAddress, headOfficeAddressValidationSchema )

    useEffect( () => {
        onValidationChange( isValid )

        
        let draft = parseDraft()
        const tempDraft = { ...draft, headOfficeAddress }
        setDraftFormData( stringifyDraft( tempDraft ))

    }, [ isValid, onValidationChange ])

    return(
        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "address" className = "col-sm-2 col-form-label">Adresse <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-6">

                    <input
                        className = { `form-control ${ ( checked && errors.address ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "address"
                        id = "address"
                        value = { headOfficeAddress.address }
                        onChange = { event => changeHeadOfficeAddress({ address: event.target.value }) }
                    />
                    {  ( checked && errors.address ) && <div className="invalid-feedback"> { errors.address } </div> }

                </div>
            </div>

            <div className = "mb-3 row">

                <label htmlFor = "adressesuite" className = "col-sm-2 col-form-label">Adresse suite</label>
                
                <div className = "col-sm-6">
                    <input
                        className = "form-control"
                        type = "text"
                        name = "adressesuite"
                        value = { headOfficeAddress.additionalAddress }
                        onChange = { event => changeHeadOfficeAddress({ additionalAddress: event.target.value })}
                    />
                </div>

            </div>

            <PostalCodeField
                checked = { checked }
                onChange = { changeHeadOfficeAddress }
                postalCode = { headOfficeAddress.postalCode }
                errors = { errors }
            />

            <div className = "mb-3 row">

                <label htmlFor = "city" className = "col-sm-2 col-form-label">Ville <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-6">

                    <select
                        className = { `form-control ${ ( checked && errors.city ) ? 'is-invalid' : ''}` }
                        name = "city"
                        id = "city"
                        onChange = { event => changeHeadOfficeAddress({ city: event.target.value }) }
                    >
                        {
                            headOfficeAddress.cities?.map( ( city, key )  => 
                                <option key = { key } value = { city }>
                                    { city }
                                </option>
                            )
                        }
                    </select>
                    {  ( checked && errors.city ) && <div className="invalid-feedback"> { errors.city } </div> }

                </div>
            </div>

            <div className = "mb-3 row">

                <label htmlFor = "registrationOffice" className = "col-sm-2 col-form-label">Greffe  <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-6">
                    <input
                        className = { `form-control ${ ( checked && errors.registrationOffice ) ? 'is-invalid' : ''}` }
                        type = "text"
                        id = "registrationOffice"
                        value = { headOfficeAddress.registrationOffice !== "" ? getCityWithPreposition( headOfficeAddress.registrationOffice ) : "" }
                        onChange = { event => changeHeadOfficeAddress({ registrationOffice: event.target.value }) }
                    />
                    {  ( checked && errors.registrationOffice ) && <div className="invalid-feedback"> { errors.registrationOffice } </div> }
                </div>

            </div>

        </div>
    )
}